import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'catalog'
})
export class CatalogPipe implements PipeTransform {

  transform(items: any[], searchText: string): unknown {
    if (!items) return [];
    if (!searchText) return items;
  
    searchText = searchText.toLowerCase();
  
    return items.filter( it => {
      return it.Nombre.toLowerCase().includes(searchText)
      || it.FechaCreacion.toLowerCase().includes(searchText);
    });
  }

}